import type { ComponentType } from 'react';

import { NoPermissionsPage } from '@adflow/frontend/ui-common';
import type { permissionSystem } from '@adflow/shared/util-permissions';

import { Can } from './Can';

interface CanRouteProps {
	I: permissionSystem.ActionType;
	a: permissionSystem.PermissionType;
	Component: ComponentType;
}

export function CanRoute({ I, a, Component }: CanRouteProps) {
	return (
		<Can I={I} a={a} passThrough>
			{(can) => (can ? <Component /> : <NoPermissionsPage />)}
		</Can>
	);
}
